import { useEffect, useState } from "react";

const EMOJI = { tax: "🧾", payroll: "👥", social_security: "👥", licensing: "🏛️", corporate: "📑", internal: "📌", insurance: "🛡️", property: "🏠", contract: "📝", certification: "📜" };
export const emo = (c) => EMOJI[c] || "📄";
export const daysTo = (d) => Math.round((new Date(`${d.slice(0, 10)}T00:00:00`) - new Date(new Date().toDateString())) / 86400000);
export const FS = (d) => new Date(`${d.slice(0, 10)}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
export const FL = (d) => (d ? new Date(`${d.slice(0, 10)}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const left = (d) => { const n = daysTo(d); return n < 0 ? `${-n}d overdue` : n === 0 ? "Due today" : `${n} days left`; };
export const dueCol = (d) => { const n = daysTo(d); return n < 0 ? "var(--er)" : n <= 7 ? "var(--wa)" : "var(--ac)"; };
export const TZ = (n) => `TZS ${Number(n || 0).toLocaleString("en-US")}`;
export const initials = (n) => (n || "").split(/\s+/).filter(Boolean).map((w) => w[0]).join("").slice(0, 2).toUpperCase() || "U";

export const Chip = ({ c, children, id }) => <span className="chip" style={{ "--c": c }} data-testid={id}>{children}</span>;

export function Drawer({ open, onClose, children, id }) {
  useEffect(() => {
    const k = (e) => { if (e.key === "Escape" && !document.querySelector("[role=dialog][data-state=open]")) onClose(); };
    if (open) document.addEventListener("keydown", k);
    return () => document.removeEventListener("keydown", k);
  }, [open, onClose]);
  return <><div className={`scr ${open ? "on" : ""}`} onClick={onClose} data-testid={`${id}-scrim`} /><aside className={`dr ${open ? "on" : ""}`} data-testid={open ? id : undefined} aria-hidden={!open}>{open && children}</aside></>;
}

export const DrHead = ({ label, onClose }) => <div className="r sp"><small>{label}</small><button className="x" onClick={onClose} aria-label="Close" data-testid="drawer-close-btn">✕</button></div>;

export function useCount(target) {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (target == null) return undefined;
    const t0 = performance.now();
    let raf;
    const step = () => { const p = Math.min(1, (performance.now() - t0) / 900); setV(Math.round(target * p)); if (p < 1) raf = requestAnimationFrame(step); };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target]);
  return v;
}
